module.exports = __webpack_public_path__ + "img/step07_a_stand_basic_lock_wheels.00871718.png";